import React from "react";
import { motion } from "framer-motion";
// import Image from "next/image";
import { Box } from "@mui/material";
import LottieAnimation from "./LottieAnimation";

const PageLoader = () => {
  return (
    <motion.div
      initial={{
        opacity: "1",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        width: "100%",
        background: "#FFF",
        zIndex: "7",
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
      }}
    >
      <Box
        sx={{
          display: "block",
          width: "240px",
          height: "375px",
        }}
      >
        {/*<Image*/}
        {/*  src={"/loading.webp"}*/}
        {/*  alt="loading"*/}
        {/*  layout={"responsive"}*/}
        {/*  width={240}*/}
        {/*  height={375}*/}
        {/*/>*/}
        <LottieAnimation />
      </Box>
    </motion.div>
  );
};

export default PageLoader;
